import CommodityExchange from "domain/commodityExchange";
import { isNullOrEmpty } from "common/strings";
import { OrderType } from "domain/orderType";
import { DeliveryMethod } from "domain/deliveryMethod";
import { LocationBase } from "domain/physicalLocation";
import { ContractType } from "domain/contract";

export class TraderThin {
  userId: string = "";
  firstName: string = "";
  lastName: string = "";
}

export class Trader extends TraderThin {
  erpId: string = null;
  email: string = "";
  phone: string = "";
  cellPhone: string = null;
  maxOfferQuantity: number = 0;
  defaultDeliveryMethod: DeliveryMethod;
  priceLock: string = null;
  castId: string = "";

  canUpdateBids: boolean = false;
  canViewReports: boolean = false;
  canPlaceHedges: boolean = false;
  canBuyNow: boolean = false;
  canPushBasis: boolean = false;
  canUseAutoOffer: boolean = false;
  canUseAutoPosition: boolean = false;
  canManageTraders: boolean = false;
  canUseSnapshotQuotes: boolean = false;
  canBuy: boolean = false;
  canSell: boolean = false;
  canSendCommunications: boolean = false;
  canManualEntry: boolean = false;
  canRetrySync: boolean = false;

  realTimeExchanges: CommodityExchange[] = [];
  isNonProUser: boolean;
  canViewPosition: boolean = false;
  canEditContracts: boolean = false;
  orderType: OrderType;
  locations: LocationBase[]= [];
  contractTypes: ContractType[];
}

export function getTraderDisplayName(trader: TraderThin): string {
  if (trader == null)
    return "";
  if (isNullOrEmpty(trader.firstName))
    return trader.lastName;
  return `${trader.lastName}, ${trader.firstName}`;
}